// extracted by mini-css-extract-plugin
module.exports =  {"saturation":"saturation__h07OE","hue":"hue__oEGPP"};